import { useFetchFeatureFlagsQuery } from "../redux/api/featureFlags"

export const useCheckForFeatureFlag = (
  flagToFind?: string,
  options?: { skip?: boolean },
) => {
  const { data: featureFlags = [] } = useFetchFeatureFlagsQuery(undefined, {
    skip: options?.skip,
  })

  // If flag is not specified, return as if it was enabled.
  // This is purely for convenience, so that we do not have to
  // do falsy checks when calling the function.
  if (!flagToFind) {
    return true
  }

  return !!featureFlags.find((featureFlag) => flagToFind === featureFlag.name)
}
